import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const ReturnsSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const returnsContent = content[language].returns;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="returns" 
      ref={sectionRef}
      className="section section-ivory"
    >
      <div className="container">
        {/* Header */}
        <div className={`text-center mb-64 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="mb-32">{returnsContent.title}</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            {returnsContent.intro}
          </p>
        </div>

        {/* Value Layers */}
        <div style={{ display: 'grid', gap: '32px' }}>
          {returnsContent.layers.map((layer, index) => (
            <div
              key={layer.title}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '40px 48px',
                background: '#ffffff',
                border: '1px solid rgba(0,0,0,0.08)',
                transitionDelay: `${index * 0.1}s`
              }}
            >
              <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '16px' }}>
                <div style={{
                  fontSize: '2rem',
                  fontFamily: 'Playfair Display, serif',
                  color: 'var(--gold)',
                  marginRight: '16px',
                  fontWeight: 400
                }}>
                  {index + 1}
                </div>
                <h4 style={{ fontSize: '1.25rem', fontWeight: 500, margin: 0 }}>
                  {layer.title}
                </h4>
              </div>
              <p style={{ fontSize: '0.9375rem', margin: 0, paddingLeft: '48px' }}>
                {layer.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReturnsSection;
